import { useEffect, useMemo, useState } from "react";
import ProcessType from "./ProcessType";

export default function ProcessButton({
    processType,
    selector,
    selected,
}: {
    processType: ProcessType;
    selector: (p: ProcessType) => void;
    selected: ProcessType | undefined;
}): JSX.Element {
    const [backgroundColor, setBackgroundColor] = useState("none");
    const [newProcessType, setNewProcessType] = useState(processType);
    const [dropdownValue, setDropdownValue] = useState(1);

    const onSelectProcessType = () => {
        setNewProcessType((prev) => {
            prev.numberof = dropdownValue;
            return prev;
        });

        selector(newProcessType);
    };

    useMemo(() => {
        setNewProcessType((prev) => {
            prev.numberof = dropdownValue;
            return prev;
        });
        selector(newProcessType);
    }, [dropdownValue, newProcessType]);

    useEffect(() => {
        setBackgroundColor(
            selected && selected.name == processType.name
                ? processType.titleColor + "55"
                : "#00000000"
        );
    }, [selected]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "12em",
                height: "10em",
                borderRadius: "1em",
                border: "2px solid #000",
                backgroundColor: backgroundColor,
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "10em",
                    marginBottom: "0.5em",
                    fontSize: "1.25em",
                    color: "#000",
                }}
            >
                <i className={processType.icon}></i>&nbsp;
                <span>{processType.name}</span>
            </div>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "10em",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "4em",
                    }}
                >
                    {processType.numberof === null ||
                    processType.numberof === undefined ? (
                        <select>
                            <option value="1">1&nbsp;</option>
                        </select>
                    ) : (
                        <select
                            onChange={(event) => {
                                setDropdownValue(+event.currentTarget.value);
                            }}
                        >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                        </select>
                    )}
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "4em",
                        backgroundColor: processType.titleColor,
                        color: processType.textColor,
                        borderRadius: "1em",
                        opacity: 0.5,
                        transition: "opacity 0.5s ease-in-out",
                        cursor: "pointer",
                    }}
                    onClick={onSelectProcessType}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.opacity =
                            e.currentTarget.style.opacity.replace(
                                e.currentTarget.style.opacity,
                                "1.0"
                            );
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.opacity =
                            e.currentTarget.style.opacity.replace(
                                e.currentTarget.style.opacity,
                                "0.5"
                            );
                    }}
                >
                    <span>Select</span>
                </div>
            </div>
        </div>
    );
}
